import { apiClient } from "../config";

async function deletePerson(id: any) {
  const res = await apiClient.delete(`/admin/users/person/${id}`);
  return res.data;
}

export default deletePerson;
